import React, { useContext } from 'react'
import { IconName, IconsLibrary } from 'core/constants/IconsLibrary'
import { useTranslation } from 'react-i18next'
import { FieldLabel } from 'core/components/common/FieldLabel'
import { FormColorPickerInput } from 'core/components/common/FormColorPickerInput'
import { IIconeService } from 'core/interfaces/Service'
import { DarkThemeContext } from 'core/contexts/DarkThemeContext'

export const IconSelector: React.FC<{
  handleSubmit: (icon: IIconeService) => void
  handleCancel: () => void
  icon: IIconeService
}> = ({ handleSubmit, handleCancel, icon }) => {
  const { t } = useTranslation()
  const [iconInfo, setIconInfo] = React.useState<IIconeService>(icon)
  const { isDarkTheme } = useContext(DarkThemeContext)
  return (
    <div className="flex flex-col">
      <div className="flex flex-row gap-x-[30px]">
        <div className="flex flex-col">
          <FormColorPickerInput
            label={t('applications.form.iconSelector.bgLabel')}
            color={iconInfo.colorBackground}
            setColor={(color) =>
              setIconInfo({
                ...iconInfo,
                colorBackground: color,
              })
            }
          />

          <FormColorPickerInput
            label={t('applications.form.iconSelector.iconColorLabel')}
            color={iconInfo.colorIcon}
            setColor={(color) =>
              setIconInfo({
                ...iconInfo,
                colorIcon: color,
              })
            }
            className="mt-[30px]"
          />
        </div>
        <div>
          <FieldLabel
            label={t('applications.form.iconSelector.iconLabel')}
            className="label-form-color"
          />
          <div className="icon-library-grid">
            {Object.entries(IconsLibrary).map(
              ([iconName, IconComponent], index) => (
                <div
                  key={index}
                  className={`flex justify-center items-center p-3 ${
                    (index + 1) % 7 !== 0 ? 'border-r border-gray-1225' : ''
                  }`}
                >
                  <div
                    onClick={() =>
                      setIconInfo({ ...iconInfo, svg: iconName as IconName })
                    }
                    className="h-[40px] w-[40px] hover:cursor-pointer rounded-full flex items-center justify-center hover:bg-blue-100"
                    style={{
                      backgroundColor:
                        iconInfo.svg === iconName
                          ? iconInfo.colorBackground
                          : isDarkTheme
                            ? '#4D5154'
                            : '#EEF1F6',
                    }}
                  >
                    <IconComponent
                      style={{
                        width: 24,
                        height: 24,
                        color:
                          iconInfo.svg === iconName
                            ? iconInfo.colorIcon
                            : 'currentcolor',
                      }}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-row items-center justify-end mt-[30px]">
        <button className="small-btn cancel hidden" onClick={handleCancel}>
          {t('global.form.button.cancel')}
        </button>
        <button
          className="small-btn default w-full md:w-auto px-30px ml-[20px]"
          onClick={() => handleSubmit(iconInfo)}
        >
          {t('applications.form.iconSelector.submit')}
        </button>
      </div>
    </div>
  )
}
